/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetLayoutsByDivisionIdDivisionIdGet$Params {
  divisionId: string;
}

export function getLayoutsByDivisionIdDivisionIdGet(http: HttpClient, rootUrl: string, params: GetLayoutsByDivisionIdDivisionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getLayoutsByDivisionIdDivisionIdGet.PATH, 'get');
  if (params) {
    rb.path('divisionId', params.divisionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getLayoutsByDivisionIdDivisionIdGet.PATH = '/GetLayoutsByDivisionId/{divisionId}';
